import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface IPagesMetaData {
  pageName: string
}

export interface PagesMetaDataInitialState {
  data: IPagesMetaData
  loading: boolean
  error: string
}

const initialState: PagesMetaDataInitialState = {
  data: { pageName: '' },
  loading: false,
  error: '',
}

const PageMetaDataSlice = createSlice({
  name: 'pageMetaDataSlice',
  initialState,
  reducers: {
    setPageName: (state, action: PayloadAction<string>) => {
      state.data.pageName = action.payload
    },
  },
})

export const PageMetaDataActions = {
  ...PageMetaDataSlice.actions,
}

export const PageMetaDataReducer = PageMetaDataSlice.reducer
